import { formatMoney } from "//nuxe.co.jp/cdn/shop/t/12/assets/theme.js?v=109729746023501300491764653040";

if ( typeof ProductsSet !== 'function' ) {
  class ProductsSet extends HTMLElement {
  
      constructor() {
        super();
        this.reduction = this.dataset.reduction;
  
        this.initSet();
        this.checkSet();
      }
      connectedCallback() {
        this.querySelector('[data-js-add-set-to-cart]' ).addEventListener('click', e =>{
  
          let items = [];
          Object.keys(this.set).map(key=>{
            if ( this.set[key] !== null ) {
              const properties = this.setProperties[key] !== null ? this.setProperties[key] : {};
              items.push({
                id: this.set[key],
                quantity: 1,
                properties: properties
              })
            }
          });
          if ( items.length > 0 ) {
            const sectionCartDrawer = document.querySelector('cart-drawer')?.closest('.shopify-section')?.id?.replace('shopify-section-','');
            if (sectionCartDrawer) {
              fetch(`${Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({'items': items, 'sections':sectionCartDrawer})
              })
              .then(response => {
                this.updateCart(response);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }

          }
  
        });
      }
      async updateCart(response) {
        const responseJson = await response.json();
        const multiple_quick_buy = document.querySelector('quick-buy-multiple-drawer');
        const errorSelector = multiple_quick_buy.querySelector('.js-error');
        const contentSelector = multiple_quick_buy.querySelector('.js-content');
   
        if(response.ok) {
          let count = this.dataset.set;
          errorSelector.classList.add('hidden');
          contentSelector.classList.remove('hidden');
          multiple_quick_buy.querySelector('.js-qb-nb-products span').textContent = count;
          multiple_quick_buy.show();
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"]
            }
          }));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          errorSelector.querySelector('span').textContent = responseJson["message"];
          errorSelector.querySelector('p').textContent = responseJson["description"];
          errorSelector.classList.remove('hidden');
          contentSelector.classList.add('hidden');
          multiple_quick_buy.show();
        }
      }
      initSet(){
  
        this.set = {};
        this.setProperties = {};
  
        this.querySelectorAll('.id_product').forEach(elm=>{
          this.set[elm.dataset.id] = elm.value;
        });

        this.querySelectorAll('.id_product_properties').forEach(elm => {
          if (elm.dataset.vapreduc !== null) {
            const properties = {
              "_vap_reduc": elm.dataset.vapreduc,
              "_vap_name": elm.dataset.vapname,
              "_vap_message": elm.dataset.vapmessage,
              "_vap_segment": elm.dataset.vapsegment
            };
            this.setProperties[elm.dataset.id] = properties;
          }
        });
        
        // bloc js ci-dessous à refacto pour le theme impact : 
        this.querySelectorAll('product-variants').forEach(elm=>{
          if ( ! elm.hasAttribute('data-has-variants') && ! elm.hasAttribute('data-unavailable') ) {
            this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
          } else {
            this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
            elm.addEventListener('VARIANT_CHANGE', e=>{
              let variant = e.target.currentVariant;
              if ( variant ) {
                this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
                elm.closest('[data-js-product-item]').classList.add('selected');

              } else {
                this.set[elm.dataset.id] = null;
              }
              this.calculatePrice()
            })
          }
        });
        this.checkSet();
        this.calculatePrice()
      }
  
      checkSet() {
        let setFull = true;
  
        Object.keys(this.set).map(key=>{
          if ( this.set[key] === null ) {
            setFull = false;
          }
        })
  
        if ( setFull && this.classList.contains('products-set--empty' ) ) {
          this.classList.remove('products-set--empty');
          // this.querySelector('[data-js-add-set-to-cart-text]').textContent = 'ajouter au panier';
        } else if ( ! setFull && ! this.classList.contains('products-set--empty' ) ) {
          this.classList.add('products-set--empty');
        }
  
        return setFull;
  
      }
  
      returnToDefaultSate(){
        this.querySelectorAll('product-variants').forEach(elm=>{
          elm.querySelectorAll('input').forEach(input=>{
            input.checked = false;
          })
          elm.querySelectorAll('select').forEach(select=>{
            select.selectedIndex = 0;
          })
          if ( ! ( ! elm.hasAttribute('data-has-variants') && ! elm.hasAttribute('data-unavailable') ) ) {
            elm.currentVariant = undefined;
            elm.parentNode.querySelector('[data-js-product-add-to-cart]').classList.add('disabled');
          } 
        });
        this.querySelectorAll('[data-js-product-item]').forEach(elm=>{
          elm.classList.remove('selected');
        });
        this.initSet();
        this.checkSet();
      }
  
      calculatePrice(){
        this.reducePrice = 0;
        var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

        this.querySelectorAll('sale-price').forEach(elm=>{
          const itemPrice = parseFloat(elm.dataset.price);
          const parent = elm.closest('product-card').querySelector('.id_product_properties');
          let isVap = false;
          if(parent) {
            isVap = parent.dataset.vapreduc !== null;
          }
          if(isVap) {
            this.reducePrice += itemPrice; 
          }else{
            this.reducePrice += itemPrice * (100 - this.reduction) / 100;
          }
        });


        this.querySelector('.set-price').innerHTML = formatMoney( Math.ceil(this.reducePrice), currencyFormat);
      }
    }
  
    if ( typeof customElements.get('products-set') == 'undefined' ) {
      customElements.define('products-set', ProductsSet);
    }
  }
